import { type ReactElement, useCallback, useState } from 'react'
import { getClipboard } from '@/utils/clipboard'
import { Body2White } from '@/components/typography'
import { Grid, Input } from '@mui/material'
// import { QrCodeScannerRounded } from '@mui/icons-material'
import { useCurrentChain } from '@/hooks/useChains'
// import ModalButton from '@/components/common/ModalButton'
// import { QrReader, type OnResultFunction } from 'react-qr-reader'
// import { ModalButtonContext } from '@/components/common/ModalButton'
// import { cleanInputValue, parsePrefixedAddress } from '@/utils/addresses'
// import { isValidAddress } from '@/utils/validation'
import ScanQRButton from '../ScanQRModal/ScanQRButton'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'

const TextInputComponent = ({
  id,
  label,
  value,
  onChange,
  errorMessages,
  showPasteButton = false,
  prefixNetwork = false,
  showQRButton = false,
  isPassword = false,
  labelBold = false,
}: {
  id: string
  label: string
  value: string
  onChange: (id: string, val: string) => void
  errorMessages: string | undefined
  showPasteButton?: boolean
  prefixNetwork?: boolean
  showQRButton?: boolean
  isPassword?: boolean
  labelBold?: boolean
}): ReactElement => {
  const [hidePassword, setHidePassword] = useState(true)
  // const [qrData, setQrData] = useState('')
  const chainInfo = useCurrentChain()
  const prefix = chainInfo?.shortName || ''

  const onPaste = useCallback(async () => {
    // Errors are handled by in getClipboard
    const clipboard = await getClipboard()

    if (clipboard) {
      onChange(id, clipboard)
    }
  }, [id, onChange])

  const handleQrData = (result: string) => {
    onChange(id, result)
  }

  const endAdornmentRender = () => {
    if (isPassword) {
      return hidePassword ? (
        <VisibilityOutlinedIcon
          sx={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', fontSize: '18px' }}
          onClick={() => setHidePassword(false)}
        />
      ) : (
        <VisibilityOffOutlinedIcon
          sx={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', fontSize: '18px' }}
          onClick={() => setHidePassword(true)}
        />
      )
    }

    return showQRButton ? <ScanQRButton onScan={handleQrData} /> : undefined
  }

  return (
    <Grid item xs={12} mb="10px">
      <Body2White sx={{ fontWeight: labelBold ? 'bold' : '400' }}>{label}</Body2White>
      <Input
        id={id}
        disableUnderline
        type={isPassword && hidePassword ? 'password' : 'text'}
        sx={{
          width: '100%',
          borderRadius: '4px',
          backgroundColor: 'var(--Supporting-Dark-BG-700, #272A3E)',
          padding: '5px 16px',
          fontSize: '14px',
          color: 'var(--Ebony-Clay-300, #D2D7E5)',
          border: errorMessages ? '1px solid var(--Supporting-Carnation, #FF2239)' : 'none',
          paddingRight: showPasteButton || showQRButton ? '0px' : '16px',
        }}
        value={value}
        onChange={(e) => onChange(e.target.id, e.target.value)}
        startAdornment={prefixNetwork ? <Body2White>{prefix}: </Body2White> : undefined}
        endAdornment={
          // showPasteButton ? (
          //   <IconButton sx={{ color: '#D2D7E5' }} onClick={onPaste}>
          //     <ContentPaste fontSize="small" />
          //   </IconButton>
          // ) : undefined
          // showQRButton ? (
          //   <ModalButton
          //     titleModal={'Scan QR Code'}
          //     contentModal={<QrCodeReaderModalContent onResult={handleQrData} />}
          //   >
          //     <IconButton
          //       sx={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', padding: 0, marginX: '8px', fontSize: '22px' }}
          //     >
          //       <QrCodeScannerRounded fontSize="inherit" />
          //     </IconButton>
          //   </ModalButton>
          // ) : undefined
          // showQRButton ? (
          //   <ScanQRButton onScan={handleQrData} />
          // ) : isPassword ? (
          //   <VisibilityOutlinedIcon sx={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', fontSize: '18px' }} />
          // ) : undefined
          endAdornmentRender()
        }
      />
      {errorMessages && <Body2White sx={{ color: 'var(--Supporting-Carnation, #FF2239)' }}>{errorMessages}</Body2White>}
    </Grid>
  )
}

// const QrCodeReaderModalContent = ({ onResult }: { onResult: (data: string) => void }): ReactElement => {
//   const { setModalOpen } = useContext(ModalButtonContext)
//   const [cameraBlocked, setCameraBlocked] = useState<boolean>(false)

//   const handleQrData: OnResultFunction = (result, error) => {
//     if (result) {
//       const data = result.getText()
//       const cleaned = cleanInputValue(data)
//       const parsed = parsePrefixedAddress(cleaned)
//       if (isValidAddress(parsed.address)) {
//         onResult(parsed.address)
//         setModalOpen(false)
//       }
//     }
//   }

//   return <QrReader constraints={{ facingMode: 'user' }} onResult={handleQrData} />
// }

export default TextInputComponent
